import { useContext } from "react";
import { UserData } from "../../types/authData";
import { UserContext } from "./context";
import { User } from "./types";

export * from "./context";

export default function useUser(): UserData<User> {
  const context = useContext(UserContext);

  if (context === null) {
    throw new Error("useUser must be used within a UserContextProvider");
  }

  return context;
}
